// extracted by mini-css-extract-plugin
export var menuIcon = "_o8-0";
export var menuIconInline = "_o8-1";